import React, { type FunctionComponent } from 'react'
import { TextField } from 'ic-snacks'
import { type FormikProps } from 'formik'
import { type DropdownOption } from 'legacy/common/types'
import { type ProductFormValues } from 'legacy/routes/catalog/types/product.types'
import FormSection from './FormSection'
import FormField from './FormField'
import ProductBrand from './ProductBrand'
import ProductTypeInfoModal from './ProductTypeInfoModal'
import { useHasAccess } from 'legacy/components/AccessControl/useHasAccess'
import { Flipper } from 'legacy/contexts/flipper/FlipperContext'

type Props = {
  brands: DropdownOption[]
} & FormikProps<ProductFormValues>

export const ProductInfo: FunctionComponent<Props> = ({
  handleChange,
  values,
  brands,
  setFieldValue,
  errors,
}) => {
  const displayProductCategoryPath = useHasAccess({
    warehouseFlippers: Flipper.DisplayProductCategoryPathInProductDetails,
  })

  return (
    <FormSection
      titleId="catalog.product.info"
      renderAction={() => (values.editable ? null : <ProductTypeInfoModal />)}
    >
      <TextField
        name="name"
        value={values.name}
        onChange={handleChange}
        required
        disabled={!values.editable}
        floatingLabelText="Product Name"
        autoComplete="off"
        fullWidth
      />
      <FormField>
        <ProductBrand
          values={values}
          onChange={handleChange}
          setFieldValue={setFieldValue}
          brands={brands}
        />
      </FormField>
      {displayProductCategoryPath && (
        <FormField>
          <TextField
            name="product_category_path"
            value={values.product_category_path}
            disabled
            floatingLabelText="Category"
            autoComplete="off"
            fullWidth
          />
        </FormField>
      )}
      <div style={{ display: 'flex', width: '100%' }}>
        <TextField
          name="size"
          value={values.size}
          onChange={handleChange}
          required
          disabled={!values.editable}
          floatingLabelText="Size"
          autoComplete="off"
          fullWidth
          hasError={!!errors.size}
          validationErrorText={errors.size}
        />
        <div style={{ width: '40px' }} />
        <TextField
          name="unit_count"
          value={values.unit_count}
          onChange={handleChange}
          required
          disabled={!values.editable}
          floatingLabelText="Unit"
          autoComplete="off"
          fullWidth
          hasError={!!errors.unit_count}
          validationErrorText={errors.unit_count}
        />
      </div>
    </FormSection>
  )
}
